module.exports = __webpack_public_path__ + "static/media/logo_blanco3.3ce501fa.png";